import { addMonths } from 'date-fns';
import { BaseService } from './BaseService';
import { ConfigApi } from '../config/Constantes';

class OrcamentoService extends BaseService {
  constructor() {
    super(`${ConfigApi.orcamentoURL}`);
  }

  getFilter() {
    return new Filter();
  }

  async getReport(id, exibirApenasModulosContratados) {
    this.setLoading(true);

    try {
      const response = await this.api.get(
        `${this.url}/report/simples/${id}?exibirApenasModulosContratados=${exibirApenasModulosContratados}`,
        {
          responseType: 'blob',
        }
      );

      return response.data;
    } finally {
      this.setLoading(false);
    }
  }
}

class Filter {
  constructor() {
    this.nome = '';
    this.idRevenda = undefined;
    this.dataInicio = addMonths(new Date(), -12 * 10);
    this.dataFim = addMonths(new Date(), 3);

    this.resumo = '';
    this.limit = 11;
    this.page = 0;
  }
}

export default new OrcamentoService();
